export const serviceTypes = {
  PERSONALLY: 1,
  FIXED_PERCENT: 2,
  FIXED_AMOUNT: 3,
  NONE: 4
}
